import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {Sector} from '../../shared/model/sector/sector.model';

@Component({
  selector: 'app-operating-unit-new',
  templateUrl: './operating-unit-new.component.html',
  styleUrls: ['./operating-unit-new.component.css']
})
export class OperatingUnitNewComponent implements OnInit {
  sectors: Sector[] = [];

  constructor(private route: ActivatedRoute) {
    this.listSectors();
  }

  ngOnInit() {
  }

  private listSectors() {
    const data = this.route.snapshot.data['sectors'];
    Object.assign(this.sectors, data);
  }
}
